import { reducer as addJob } from './addJob'
import { reducer as deleteJob } from './deleteJob'
import { reducer as getJob } from './getJob'
import { reducer as getJobs } from './getJobs'
import { reducer as jobAddModal } from './jobAddModal'
import { reducer as updateJob } from './updateJob'
import { reducer as getJobTypes } from './getJobTypes'
import { reducer as jobEditModal } from './jobEditModal'
import { reducer as jobViewModal } from './jobViewModal'

export default {
  addJob,
  deleteJob,
  getJob,
  getJobs,
  jobAddModal,
  updateJob,
  getJobTypes,
  jobEditModal,
  jobViewModal
}



// WEBPACK FOOTER //
// ./src/store/jobs/index.js